import { IconName } from '@fortawesome/fontawesome-svg-core';
import { SidebarSubsectionHeader } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection/SidebarSubsectionHeader';
import { EBorders, EHovers } from 'libs/styles/styling';
import React, { useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    className?: string;

    title: string;
    initialExpanded?: boolean;
    disableBottomBorder?: boolean;
    expandable?: boolean;
    icon: {
        iconName: IconName;
    };
    children?: React.ReactNode;
}

export const SidebarSubsection = (props: Props): JSX.Element => {
    const [expanded, setExpanded] = useState(props.initialExpanded ?? true);

    return (
        <S_SidebarSubsection
            className={props.className}
            $disableBottomBorder={props.disableBottomBorder}
        >
            <SidebarSubsectionHeader
                icon={{
                    iconPrefix: 'fal',
                    iconName: props.icon.iconName
                }}
                title={props.title}
                expanded={expanded}
                expandable={props.expandable}
                onExpandClick={() => {
                    setExpanded((val) => !val);
                }}
            />
            {(expanded || !props.expandable) && props.children}
        </S_SidebarSubsection>
    );
};

const S_SidebarSubsection = styled.div<{ $disableBottomBorder?: boolean }>`
    border-bottom: ${(props) =>
        props.$disableBottomBorder ? 'none' : '1px solid' + EBorders.DARK};
    &:hover {
        box-shadow: ${EHovers.LIGHT4};
    }
`;
